import { render, staticRenderFns } from "./ModalChangeStatus.vue?vue&type=template&id=65d5ac82"
import script from "./ModalChangeStatus.vue?vue&type=script&lang=js"
export * from "./ModalChangeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports